const privacyConfig = {
  organizationName: process.env.REACT_APP_ORGANIZATION_NAME || 'Centre de Jour Vivre en Santé',
  responsibleTitleFr: process.env.REACT_APP_PRIVACY_RESPONSIBLE_TITLE_FR || 'Responsable de la protection des renseignements personnels',
  responsibleTitleEn: process.env.REACT_APP_PRIVACY_RESPONSIBLE_TITLE_EN || 'Privacy Officer',
  responsibleName: process.env.REACT_APP_PRIVACY_RESPONSIBLE_NAME || 'Jean-Paul Tremblay',
  responsibleEmail: process.env.REACT_APP_PRIVACY_RESPONSIBLE_EMAIL || 'confidentialite@centredejourensante.ca',
  responsiblePhone: process.env.REACT_APP_PRIVACY_RESPONSIBLE_PHONE || '',
  responsibleAddressFr: process.env.REACT_APP_PRIVACY_RESPONSIBLE_ADDRESS_FR || '',
  responsibleAddressEn: process.env.REACT_APP_PRIVACY_RESPONSIBLE_ADDRESS_EN || '',
  lastUpdated: process.env.REACT_APP_PRIVACY_LAST_UPDATED || '2026-03-15',
};

export default privacyConfig;
